import {
  EXERCISE_KEY,
  getByIdExerciseSelector
} from '@gymaholic/packages'
import Text from 'components/Text'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import ExerciseMediaImage from 'containers/ExerciseMediaImage'
import { Image } from 'components/Image'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'
import { ListRowItemWithImage } from 'components/ListRowItemWithImage/index.js'
import { getImageStyleListRowItemUtil } from 'components/ListRowItemWithImage/utils/get-image-style/index.js'

/**
 * @param props
 * @param props.id
 * @param props.style
 * @param props.onClick
 * @return {Element}
 * @constructor
 */
export default function ExerciseRow ({
  id,
  style,
  onClick
}) {
  const exercise = useSelector(getByIdExerciseSelector(id))
  const name = getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
  const slug = getSlugExerciseNameUtil(name)

  const handleClick = () => {
    onClick(id, slug)
  }

  const imageElement = (
    <ExerciseMediaImage
      id={id}
      aspectRatio={Image.ASPECT_RATIO.TALL}
      style={getImageStyleListRowItemUtil()}
    />
  )

  return (
    <ListRowItemWithImage
      style={style}
      onClick={handleClick}
      imageElement={imageElement}
    >
      <Text
        c='#000000'
        ml='1.2em'
        style={{ textAlign: 'left' }}
      >
        {name}
      </Text>
    </ListRowItemWithImage>
  )
}
